import React, { Component } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Logo from "../../assets/img/logo/logo.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faLinkedinIn, faInstagram } from '@fortawesome/free-brands-svg-icons';

const styles = {
    p: {
        color: "rgb(137, 135, 140)",
        fontFamily: "BunueloLight"
    },
    circle: {
        background: "radial-gradient(circle closest-side,#69f2ef 0%,#69f2ef 98%,rgba(0,0,0,0) 100%)",
        width: "30px",
        height: "30px",
        fontSize: "12px",
        color: "#000"
    }
}

export default class Footer extends Component {

    render() {

        return (
            <section className="bg-white py-4">
                <Container>
                    <Row className="py-2">
                        <Col xs={12} sm={3} className="d-flex align-items-center justify-content-center justify-content-sm-start mb-4 mb-sm-0">
                            <a href="https://www.facebook.com/peopleviewbr" rel="noopener noreferrer" target="_Blank" style={styles.circle} className="d-flex align-items-center justify-content-center mr-1"><FontAwesomeIcon icon={faFacebookF} /></a>
                            <a href="https://www.instagram.com/peopleviewbr/" rel="noopener noreferrer" target="_Blank" style={styles.circle} className="d-flex align-items-center justify-content-center mr-1"><FontAwesomeIcon icon={faInstagram} /></a>
                            <a href="https://www.linkedin.com/" rel="noopener noreferrer" target="_Blank" style={styles.circle} className="d-none align-items-center justify-content-center mr-1"><FontAwesomeIcon icon={faLinkedinIn} /></a>
                        </Col>
                        <Col xs={12} sm={6} className="d-flex align-items-center justify-content-center text-center flex-column small">
                            <p className="m-0" style={styles.p}>Todas as informações cadastradas são de uso exclusivo do People View</p>
                            <p className="m-0" style={styles.p}>&copy; {new Date().getFullYear()} People View - All Rights Reserved</p>
                        </Col>
                        <Col xs={12} sm={3} className="d-none d-sm-flex align-items-center justify-content-end">
                            <img src={Logo} alt="People View" width="150px" />
                        </Col>
                    </Row>
                </Container>
            </section>
        );
    }

}